export function getAbbreviationForCreditProfile(creditProfileValue: string): string {
  switch (creditProfileValue) {
    case 'OTHER':
      return 'Other';
    case 'INVESTMENT_GRADE_ENTITY':
      return 'IG';
    case 'PARENTAL_GUARANTEE_FROM_INVESTMENT_ENTITY':
      return 'PG from IG';
    case 'PARENTAL_GUARANTEE_FROM_NON_INVESTMENT_ENTITY':
      return 'PG from Non IG';
    case 'LETTER_OF_CREDIT':
      return 'LC';
    case 'PROJECT_LIEN':
      return 'PL';
    default:
      return '';
  }
}
